import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ProductTransactions18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_665)'>
      <path d='M7 5.75V7.25H11V5.75H7Z' fill='currentColor' />
      <path d='M7 4.75V3.25H11V4.75H7Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9 0.25C4.16751 0.25 0.25 4.16751 0.25 9C0.25 13.8325 4.16751 17.75 9 17.75C13.8325 17.75 17.75 13.8325 17.75 9C17.75 4.16751 13.8325 0.25 9 0.25ZM4.75001 3.12568C5.94413 2.26024 7.41248 1.75 9 1.75C10.5875 1.75 12.0559 2.26025 13.25 3.12569V11.0384L9.66986 8.89926C9.27913 8.65882 8.76092 8.65881 8.37017 8.89925L4.75001 11.0623V3.12568ZM3.25001 4.58351C2.30932 5.80641 1.75 7.33788 1.75 9C1.75 13.0041 4.99594 16.25 9 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 7.3379 15.6907 5.80643 14.75 4.58354V11.5C14.75 12.4042 13.6782 13.0416 12.8953 12.5738L9.02001 10.2583L5.14687 12.5725C4.32752 13.068 3.24647 12.4559 3.25001 11.4983V4.58351Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_665'>
        <rect width='18' height='18' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

ProductTransactions18.displayName = 'ProductTransactions18';
export default ProductTransactions18;
